import styled from "styled-components";

/**
 * Styles for {@link ./LimitWallExpiredNotice}: the panel's quiet notice treatment, one line on the field
 * tint in the secondary ink, so it reads as information rather than as the over-limit strip's offer or the
 * send-blocked alert.
 */
export const ExpiredLine = styled.p`
	margin: 0;
	padding: 9px 11px;
	border-radius: 11px;
	background: ${({theme}) => theme.tokens.field};
	color: ${({theme}) => theme.tokens.ink2};
	font-size: 12.5px;
	line-height: 1.4;
`;
